import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "col-span-1 xl:col-span-3" }
const _hoisted_3 = {
  key: 0,
  class: "border-2 border-red-500 bg-red-50 px-5 py-4 bg rounded-md mb-4"
}
const _hoisted_4 = {
  key: 0,
  class: "flex gap-4"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "text-red-500 font-semibold" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "text-red-500 text-sm" }, " ผู้ซื้อไม่ทำการชำระเงินในเวลาที่กำหนด ", -1)
const _hoisted_8 = {
  key: 1,
  class: "flex gap-4"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "text-red-500 font-semibold" }
const _hoisted_11 = { class: "text-red-500 text-sm" }
const _hoisted_12 = { class: "text-red-500 text-sm" }
const _hoisted_13 = { class: "block xl:hidden" }
const _hoisted_14 = { class: "row-start-1 xl:row-start-auto col-span-1 order-last" }
const _hoisted_15 = { class: "hidden xl:block" }
const _hoisted_16 = {
  key: 1,
  class: "h-screen flex justify-center items-center"
}
const _hoisted_17 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_compHeader = _resolveComponent("compHeader")!
  const _component_compOrderStatus = _resolveComponent("compOrderStatus")!
  const _component_compProductInfo = _resolveComponent("compProductInfo")!
  const _component_compShipping = _resolveComponent("compShipping")!
  const _component_compPriceSummary = _resolveComponent("compPriceSummary")!
  const _component_compBill = _resolveComponent("compBill")!
  const _component_compDetailShipping = _resolveComponent("compDetailShipping")!
  const _component_expiryComp = _resolveComponent("expiryComp")!

  return (_ctx.detail)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.detail.docNo)
          ? (_openBlock(), _createBlock(_component_compHeader, {
              key: 0,
              heading: "คำสั่งซื้อ > ",
              orderId: _ctx.detail.docNo,
              companyLogo: _ctx.detail.sellerCompanyContactInfo.companyMarketLogoUrl,
              companyName: _ctx.detail.sellerCompanyContactInfo.companyMarketName
            }, null, 8, ["orderId", "companyLogo", "companyName"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["grid grid-cols-1 xl:grid-cols-4 xl:gap-4 mx-auto", _ctx.detail.paymentAttachmentData ? 'mb-0' : 'mb-70px xl:mb-0']),
          style: {"max-width":"1500px","width":"100%"}
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.detail.statusOrderOnSeller === _ctx.StatusOrder.Canceled)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_ctx.detail.hasExpired)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createElementVNode("img", {
                          class: "w-8 h-8",
                          src: require('@/assets/images/ico-abort_order.svg'),
                          alt: ""
                        }, null, 8, _hoisted_5),
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_6, " คำสั่งซื้อ " + _toDisplayString(_ctx.detail.docNo) + " ถูกยกเลิก ", 1),
                          _hoisted_7
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createElementVNode("img", {
                          class: "w-8 h-8",
                          src: require('@/assets/images/ico-abort_order.svg'),
                          alt: ""
                        }, null, 8, _hoisted_9),
                        _createElementVNode("div", null, [
                          _createElementVNode("p", _hoisted_10, " คำสั่งซื้อ " + _toDisplayString(_ctx.detail.docNo) + " ถูกยกเลิก ", 1),
                          _createElementVNode("p", _hoisted_11, " คำสั่งซื้อนี้ถูกยกเลิกโดย " + _toDisplayString(_ctx.detail.latestActionByFullName) + " เมื่อ " + _toDisplayString(_ctx.formatDate(_ctx.detail.requestCancelAt)), 1),
                          _createElementVNode("p", _hoisted_12, " หมายเหตุ : " + _toDisplayString(_ctx.detail.reason || " - "), 1)
                        ])
                      ]))
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_compOrderStatus, {
              class: "block xl:hidden",
              data: _ctx.detail
            }, null, 8, ["data"]),
            _createVNode(_component_compProductInfo, { data: _ctx.detail }, null, 8, ["data"]),
            (
            _ctx.detail.statusOrder !== _ctx.StatusOrder.Canceled ||
            (_ctx.detail.statusOrderOnSellerWhenCanceled &&
              _ctx.detail.statusOrderOnSellerWhenCanceled !==
                _ctx.StatusOrderSeller.S1_AwaitingConfirm)
          )
              ? (_openBlock(), _createBlock(_component_compShipping, {
                  key: 1,
                  ref: "compShipping",
                  data: _ctx.detail
                }, null, 8, ["data"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_compPriceSummary, {
                onClickSend: _ctx.triggerForm,
                data: _ctx.detail
              }, null, 8, ["onClickSend", "data"])
            ]),
            (
            _ctx.detail.statusOrder !== _ctx.StatusOrder.Canceled ||
            (_ctx.detail.statusOrderOnSellerWhenCanceled &&
              _ctx.detail.statusOrderOnSellerWhenCanceled !==
                _ctx.StatusOrderSeller.S1_AwaitingConfirm)
          )
              ? (_openBlock(), _createBlock(_component_compBill, {
                  key: 2,
                  data: _ctx.detail
                }, null, 8, ["data"]))
              : _createCommentVNode("", true),
            (
            _ctx.detail.statusOrder !== _ctx.StatusOrder.Canceled ||
            (_ctx.detail.statusOrderOnSellerWhenCanceled &&
              _ctx.detail.statusOrderOnSellerWhenCanceled !==
                _ctx.StatusOrderSeller.S1_AwaitingConfirm)
          )
              ? (_openBlock(), _createBlock(_component_compDetailShipping, {
                  key: 3,
                  data: _ctx.detail
                }, null, 8, ["data"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_14, [
            (_ctx.detail.expiryTimestamp && _ctx.detail.statusOrder !== _ctx.StatusOrder.Canceled && (_ctx.detail.statusOrderOnSeller === _ctx.StatusOrderSeller.S1_AwaitingConfirm || _ctx.detail.statusOrderOnSeller === _ctx.StatusOrderSeller.S2_AwaitingPayment))
              ? (_openBlock(), _createBlock(_component_expiryComp, {
                  key: 0,
                  data: _ctx.detail
                }, null, 8, ["data"]))
              : _createCommentVNode("", true),
            _createVNode(_component_compOrderStatus, {
              class: "hidden xl:block",
              data: _ctx.detail
            }, null, 8, ["data"]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_compPriceSummary, {
                onClickSend: _ctx.triggerForm,
                data: _ctx.detail
              }, null, 8, ["onClickSend", "data"])
            ])
          ])
        ], 2)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_16, [
        _createElementVNode("img", {
          class: "w-40 h-40",
          src: require('@/assets/images/animation_loading.gif')
        }, null, 8, _hoisted_17)
      ]))
}